
      window.addEventListener('load', () => {
        requestAnimationFrame(() => import('/src/main.tsx'));
      }, { once: true });
    